import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TableHeader = () => {
  const { t } = useTranslation()

  return (
    <Styles.TableHead>
      <tr>
        <Styles.CheckboxCell />
        <Styles.ProductPositionCell></Styles.ProductPositionCell>
        <Styles.TableHeader colSpan={2}>
          <Text type="allCapsS">{t('Producto')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('País de origen')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('HS Code')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('Identificadores')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('Coste unitario')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('Peso')}</Text>
        </Styles.TableHeader>
        <Styles.TableHeader>
          <Text type="allCapsS">{t('Precios exportación')}</Text>
        </Styles.TableHeader>
        <Styles.CaretDownCell></Styles.CaretDownCell>
      </tr>
    </Styles.TableHead>
  )
}

export default TableHeader
